<template>
  <div class="container text-center py-5">
    <h1 class="display-1 font-weight-bold">{{ code }}</h1>

    <h2 class="h3 my-3">{{ $t(title) }}</h2>

    <p class="lead mb-4">{{ $t(message) }}</p>

    <div class="d-flex justify-content-center flex-wrap">
      <router-link to="/" class="btn btn-primary mx-2 mb-2">
        {{ $t('buttons.go_home') }}
      </router-link>

      <button @click="goBack" class="btn btn-outline-secondary mx-2 mb-2">
        {{ $t('buttons.go_back') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  props: {
    code: { type: [String, Number], required: true },
    title: { type: String, required: true },
    message: { type: String, required: true }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
